import { NgForm, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms'
export class OTPToActivateAccount {
  public UserName: string;
  public ActorName: string;
  public UserAccountRequestCode: number;
  public ActivationCode: string;
  public MobileNo: string;
  public EmailID: string;
  constructor() {
  }
}
